<template>
  <div class="page page-projects">
    <div class="page__wrap" data-animate="page-wrap" v-if="designers">
      <PagesDesignersHeader :header="designers.generalHeader?.[0]" />

      <PagesDesignersList
        :designers="list"
        class="row-1 m-top-3"
        :class="{
          'p-bot-3': count <= limit,
        }"
      />
      <WidgetPaginationListing
        v-if="count > limit"
        class="row-1 flex --justify-center m-top-5 p-bot-3"
        :itemPerPage="limit"
        :total="count"
      />
    </div>
  </div>
</template>

<script setup>
import { useCraftStore } from '@/store/craft.js'

// Importa le query GraphQL
import queries from '@/graphql/craft/queries/index.js'

import {
  onBeforeEnter,
  onEnter,
  onLeave,
} from '~/assets/js/page-transitions/listing.js'

definePageMeta({
  layout: 'default',
  pageTransition: {
    onBeforeEnter: (el) => {
      onBeforeEnter(el)
    },
    onEnter: async (el, done) => {
      const tl = onEnter(el)
      await tl.delay(0.5).play()
      done()
    },
    onLeave: async (el, done) => {
      const tl = onLeave(el)
      await tl.play()
      window.lenis.scrollTo(0, { immediate: true })
      done()
    },
  },
})

const { configuration } = useCraftStore()
const route = useRoute()

const query = queries.designers.getDesigners

const limit = ref(100)

const variables = computed(() => ({
  site: configuration.site,
  limit: limit.value,
  offset: route.query?.page
    ? (parseInt(route.query?.page) - 1) * limit.value
    : 0,
}))
const { data } = await useGraphql(query, variables)

if (!data.value?.designersHomeEntries?.[0] || !data.value?.designersEntries) {
  throw createError({ statusCode: 404 })
}

const designers = computed(() => data.value?.designersHomeEntries?.[0])
const list = computed(() => data.value.designersEntries)
const count = computed(() => data.value?.entryCount || 0)
const seo = computed(() => data.value?.designersHomeEntries?.[0]?.seo || {})

// Seo
useSeo({
  ...seo.value,
  meta: [
    {
      name: 'description',
      content: seo.value?.description,
    },
  ],
})
</script>

<style></style>
